// import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { Result, Space, Typography } from 'antd';
import LIEnquirySubmittedIcon from 'assets/images/support/lienquiry-submitted-icon.svg';

// import { useEnquiryEmailSubmission } from 'all-in-one-shared-api';
import { PrimaryButton } from 'components';
// import { useKeycloakReady } from 'hooks/useKeycloakReady';

interface SuccessData {
  backRoute: string;
}

export const SuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { backRoute } = (location.state as SuccessData) ?? {};
  // if (!enquiryReference) {
  //   return <Navigate to="/notFound" replace={true} />;
  // }

  return (
    <Result
      icon={<img style={{ width: '153px', height: '153px' }} src={LIEnquirySubmittedIcon} />}
      extra={
        <Space direction="vertical">
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px' }}>
            {t('enum.claimStatus.SUBMITTED')}
          </Typography.Text>
          <PrimaryButton
            className="sucsesPrimaryButton"
            style={{ height: '56px', fontFamily: 'Roboto500', fontSize: '20px' }}
            onClick={() => navigate(backRoute)}
          >
            {t('common.done')}
          </PrimaryButton>
        </Space>
      }
    />
  );
};
